import React, { useState, useEffect, useRef } from 'react';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IoMdArrowRoundDown, IoMdArrowRoundUp } from "react-icons/io";
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import ReactMarkdown from 'react-markdown';
import axios from 'axios'; 
import { toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 
import { IoRefresh } from "react-icons/io5";

const ChatPanel = () => {
    const chatEndRef = useRef(null);
    const chatContainerRef = useRef(null);
    const [show, setShow] = useState(false);
    const [chat_id, setChatId] = useState('');
    const [promptForFeedback,setPromptForFeedback]=useState()
    const [prompt, setPrompt] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [messages, setMessages] = useState([{ type: 'bot', text: "Hi there! I'm Naresh, your AI Agent. Ask me anything about JustDeliveries, or select one of the options below to get started."}]);
    const [showScrollButton, setShowScrollButton] = useState(false);
    const [feedbackMessage, setFeedbackMessage] = useState(null);
    const [feedbackText, setFeedbackText] = useState('');
    const [selectedFeedbackType, setSelectedFeedbackType] = useState('');
    const [tags, setTags] = useState([
  "Learn about JustDeliveries",
  "Get our brochures",
  "Get Quotation",
  "Register as a Vendor Partner",
  "Job Enquiry"
]);

    // Generate session_id when the component mounts
    useEffect(() => {
        const generatedSessionId = uuidv4(); 
        setChatId(generatedSessionId); 
    }, []);

    useEffect(() => {
        // Scroll to the bottom of the chat whenever messages change
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages]);

    useEffect(() => {
        const handleScroll = () => {
            if (chatContainerRef.current) {
                const { scrollTop, scrollHeight, clientHeight } = chatContainerRef.current;
                if (scrollHeight > clientHeight + 10) {
                    setShowScrollButton(scrollTop + clientHeight > scrollHeight - 10);
                } else {
                    setShowScrollButton(false);
                }
            }
        };

        const chatContainer = chatContainerRef.current;
        if (chatContainer) {
            chatContainer.addEventListener('scroll', handleScroll);
            handleScroll(); // Check scroll visibility on mount
        }

        return () => {
            if (chatContainer) {
                chatContainer.removeEventListener('scroll', handleScroll);
            }
        };
    }, [messages]);

    const scrollToBottom = () => {
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleSubmit = (event, promptText = prompt) => {
    
        if (event) {
            event.preventDefault();
        }
        if (promptText === 'Get our brochures') {
            setMessages(prevMessages => [
                ...prevMessages,
                { type: 'user', text: promptText }
            ]);
            setMessages(prevMessages => [
                ...prevMessages,
                { type: 'bot', text: "Thank you for your enquiry! \n If you have any further questions, feel free to let us know. 😊" }
            ]);
            setTags([]);
            window.open('https://drive.google.com/file/d/1h9WCBYYn5Vndswz8xAPg7RxqrdjXDNjn/view', '_blank');
            return;
        }
        fetchResponse(promptText);
    };

    const fetchResponse = async (promptText = prompt) => {
        setLoading(true);
        setError(null); // reset error
        setMessages(prevMessages => [
            ...prevMessages,
            { type: 'user', text: promptText }
        ]);
        const formData = new FormData();
        formData.append('agent_id', 1); 
        formData.append('prompt', promptText);
        formData.append('chat_id',chat_id)
        setPrompt("");
        setTags([]);
        try {
            const response = await fetch('https://model.zunno.io/get-response/', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Failed to fetch response');
            }

            const data = await response.json();
            console.log(data)
            setMessages(prevMessages => [
                ...prevMessages,
                { type: 'bot', text: data?.text }
            ]);
            // Update tags if suggested_questions exist in the response
            if (data?.suggested_questions) {
                setTags([]);
            }
        } catch (error) {
            setError(error.message); // Set error message if request fails
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (event) => {
        setPrompt(event.target.value);
    };

    const handleFeedback = (message,prompt) => {
        console.log(prompt.text,'\n',message.text)
        setPromptForFeedback(prompt.text)
        setFeedbackMessage(message); // Set the message for which feedback is being provided
        setShow(true); // Open the modal
    };

    const handleSubmitFeedback = async () => {
        if (feedbackMessage) {
            // Prepare the feedback data with necessary checks
            const feedbackData = {
                prompt:promptForFeedback||"",
                message: feedbackMessage?.text || "", // Ensure message text exists
                feedback_type: selectedFeedbackType || "None", // If no feedback type is selected, default to 'None'
                feedback_text: feedbackText.trim() || "", // Send empty string if no feedback text is provided
            };
    
            // Submit the feedback using Axios (or fetch if preferred)
            try {
                await axios.post('https://jdchat.zunno.io/api/api/submit-feedback', feedbackData);
                console.log("Feedback submitted:", feedbackData);
                toast.success("Feedback submitted successfully!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
    
                // Reset states and close the modal
                setShow(false);
                setFeedbackMessage(null);
                setFeedbackText("");
                setSelectedFeedbackType('');
            } catch (error) {
                console.error('Error submitting feedback:', error);
                toast.error("Failed to submit feedback. Please try again.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } else {
            console.error("Feedback message is missing.");
            toast.error("Please provide feedback.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };
    
    const handleRefresh = () => {
        setMessages([]);
        setPrompt("");
        const newSessionId = uuidv4();
        setChatId(newSessionId);
        setTags([
  "Learn about JustDeliveries",
  "Get our brochures",
  "Get Quotation",
  "Register as a Vendor Partner",
  "Job Enquiry"
]);
    };

    return (
        <section className='h-full flex flex-col'>
            <div className="flex items-center justify-between header gap-3 fixed w-full top-0 bg-white z-10">
                <img src="/assets/images/svg/Logo.svg" alt="logo" className="md:w-[200px] w-[120px] my-3" />
                <button 
                    onClick={handleRefresh}
                    className="mr-4 p-2 rounded-full hover:bg-gray-100 transition-colors"
                    title="Refresh Chat"
                >
                    <IoRefresh className="w-5 h-5 md:w-6 md:h-6 text-gray-600" />
                </button>
            </div>
            <div className="flex flex-col h-full">
                <div className="px-4 md:px-[20px] col-xl-6 mt-[70px] md:mt-[85px] col-lg-10 col-12 mx-auto flex-grow overflow-y-auto pb-[200px]">
                    <div ref={chatContainerRef} className="pb-4">
                        <div className="space-y-4">
                            {messages.map((msg, index) => (
                                <div key={index} className={`pb-[16px] ${msg.type === 'user' ? 'text-right' : ''}`}>
                                    <span
                                        className={`px-3 md:px-[20px] inline-block py-2 md:py-[10px] spacing rounded-[20px_20px_0px_20px] ${msg.type === 'user' ? 'bg-chat-color' : 'bg-gray-200'}`}
                                    >
                                        <ReactMarkdown>{msg.text}</ReactMarkdown>
                                    </span>
                                    {msg.type !== 'user' && (
                                        <div className="flex items-center gap-2 mt-2">
                                            <OverlayTrigger
                                                placement={"bottom"}
                                                overlay={<Tooltip id={`tooltip-bottom`}><span className="!text-xs p-1 inline-block">Good</span></Tooltip>}
                                            >
                                                <img src="/assets/images/svg/thumbs-up.svg" alt="thumbs-up" className="cursor-pointer w-4 h-4 md:w-5 md:h-5" />
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                                placement={"bottom"}
                                                overlay={<Tooltip id={`tooltip-bottom`}><span className="!text-xs p-1 inline-block">Bad</span></Tooltip>}
                                            >
                                                <img
                                                    src="/assets/images/svg/thumbs-down.svg"
                                                    alt="thumbs-down"
                                                    className="cursor-pointer w-4 h-4 md:w-5 md:h-5"
                                                    onClick={() => handleFeedback(msg,messages[index-1])}
                                                />
                                            </OverlayTrigger>
                                        </div>
                                    )}
                                </div>
                            ))}
                            {loading && (
                                <div className="spinner w-8 h-8 md:w-10 md:h-10 border-4 border-t-4 border-gray-300 border-t-teal-500 rounded-full animate-spin"></div>
                            )}
                            <div ref={chatEndRef} />
                        </div>
                    </div>
                </div>
                {showScrollButton && (
                    <div
                        className="bg-white mx-auto mb-3 cursor-pointer border shadow-lg w-[30px] h-[30px] md:w-[35px] md:h-[35px] flex items-center justify-center rounded-full text-black"
                        onClick={scrollToBottom}
                    >
                        <IoMdArrowRoundDown className="w-4 h-4 md:w-5 md:h-5" />
                    </div>
                )}
            </div>
            <div className="fixed bottom-0 left-0 right-0 bg-white z-10">
                <div className="flex flex-wrap items-center justify-center gap-2 w-full px-2 md:px-4 py-2 border-t border-gray-200">
                    {tags.map((tag, index) => (
                        <span onClick={() => handleSubmit(null, tag)} key={index} className="bg-gray-200 text-gray-700 text-xs md:text-sm font-semibold px-2 py-1 rounded-full cursor-pointer">
                            {tag}
                        </span>
                    ))}
                </div>
                <div className="bg-white mx-2">
                    <div className="chat_back col-xl-6 col-lg-10 col-12 mx-auto p-[1px] rounded-[17px] w-full md:mb-4 mb-1">
                        <div className="bg-white rounded-[17px] p-2 md:p-3 shadow-[0px_1.56px_12.49px_-1.56px_#638CF352]">
                            <textarea
                                cols="30"
                                rows="1"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && !e.shiftKey) {
                                        e.preventDefault();
                                        if (prompt.trim()) {
                                            handleSubmit(e);
                                        }
                                    }
                                }}
                                placeholder="Message to JustDeliveries"
                                className="w-full disabled:bg-white resize-none placeholder:text-xs md:placeholder:text-sm outline-none"
                                value={prompt}
                                onChange={handleInputChange}
                                disabled={loading}
                            ></textarea>
                            <div className="flex items-center gap-3 justify-end">
                                <div className="flex items-center gap-3">
                                    <Link
                                        to="#"
                                        className={`bg-[#198741] border-[1px] shadow-[0px_1.56px_12.49px_-1.56px_#638CF352] border-white w-[30px] h-[30px] md:w-[35px] md:h-[35px] flex items-center justify-center rounded-full text-white ${
                                            loading || !prompt.trim() ? "opacity-50 cursor-not-allowed" : ""
                                        }`}
                                        onClick={(e) => {
                                            if (prompt.trim()) {
                                                handleSubmit(e);
                                            }
                                        }}
                                        disabled={loading || !prompt.trim()}
                                    >
                                        <IoMdArrowRoundUp className="w-4 h-4 md:w-5 md:h-5" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Feedback Modal */}
            <Modal show={show} onHide={() => setShow(false)} centered className="dislike_modal">
                <Modal.Header closeButton>
                    <Modal.Title>Feedback</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="flex items-center gap-2">
                        <div
                            className={`bg-[#D9D9D9]/40 text-sm rounded-lg px-[16px] py-[8px] cursor-pointer ${selectedFeedbackType === 'Unrelated' ? 'bg-black text-white' : ''}`}
                            onClick={() => setSelectedFeedbackType('Unrelated')}
                        >
                            Unrelated
                        </div>
                        <div
                            className={`bg-[#D9D9D9]/40 text-sm rounded-lg px-[16px] py-[8px] cursor-pointer ${selectedFeedbackType === 'Wrong' ? 'bg-black text-white' : ''}`}
                            onClick={() => setSelectedFeedbackType('Wrong')}
                        >
                            Wrong
                        </div>
                        <div
                            className={`bg-[#D9D9D9]/40 text-sm rounded-lg px-[16px] py-[8px] cursor-pointer ${selectedFeedbackType === 'Missing' ? 'bg-black text-white' : ''}`}
                            onClick={() => setSelectedFeedbackType('Missing')}
                        >
                            Missing
                        </div>
                    </div>
                    <textarea
                        cols="30"
                        rows="4"
                        className="w-full border border-black rounded-lg p-3 mt-4 resize-none placeholder:text-sm"
                        placeholder="We appreciate your feedback. Please share any comments or suggestions that you have to help us improve"
                        value={feedbackText}
                        onChange={(e) => setFeedbackText(e.target.value)}
                    />
                    <div className="text-center mt-4">
                        <button onClick={() => setShow(false)} className="border-[1px] border-black/50 px-[20px] py-[8px] hover:bg-[#f3f2f1] text-sm rounded-lg me-3">
                            Cancel
                        </button>
                        <button onClick={handleSubmitFeedback} className="border-[1px] btn_hover bg-[#198741] hover:bg-[#317c4d] text-white border-white px-[20px] py-[8px] text-sm rounded-lg">
                            Submit
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </section>
    );
};

export default ChatPanel;
